<template>
    <div>
        <date-picker
            v-model="fieldData.tempStartDate"
            :months="months"
            :weekdays="weekdays"
            :class="[fieldData.hasError ? 'errorinput' : '', 'datepicker']"
            :show-week-number="true"
            valueType="format"
            :disabled-date="isDateDisabled"
            :clearable="false"
            :lang="enSv"
        ></date-picker>
        <label class="text-danger" v-if="fieldData.errorMsg.length > 0">{{ fieldData.errorMsg }}</label>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import "vue2-datepicker/locale/en"
import computedVal from "@/mixins/computedVal"
import props from "@/mixins/inputProps"
import propsDate from "@/mixins/inputPropsDate"
import datePickerConfig from "@/mixins/datePickerConfig"
import { isDateNotBetweenTwoDates } from "../../../../api/utils.js"
import dayjs from "dayjs"
import globalConfig from "../../../../mixins/globalConfig.js"
import sv from 'vue2-datepicker/locale/sv'

export default {
    name: "DateFromAds",
    components: {
        DatePicker,
    },
    mixins: [computedVal, props, propsDate, globalConfig, datePickerConfig],
    computed: {
        enSv() {
            sv.formatLocale.monthsShort = this.monthsShort
            return {
                ...sv,
                days: [...this.weekdays],
                months: [...this.months],
            }
        },
        isDateValidFormat() {
            return dayjs(this.value, "YYYY-MM-DD").format("YYYY-MM-DD") === this.value
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        require("dayjs/locale/sv")
        dayjs.locale("sv")
        if (this.fieldData.tempStartDate) this.checkIfError(this.fieldData.tempStartDate)
    },
    methods: {
        isDateDisabled(datepickerDate) {
            let startDate = new Date(this.$store.getters.getMetadataAdFromDate)
            let endDate = new Date(this.latestDate)
            let disableDate = isDateNotBetweenTwoDates(datepickerDate, startDate, endDate)
            return disableDate
        },
        checkIfError(chosendate) {
            this.fieldData.hasError = false
            this.fieldData.errorMsg = ""
            if ((this.isDateDisabled(new Date(chosendate)) && this.fieldData.required) || !this.isDateValidFormat) {
                this.fieldData.hasError = true
                this.fieldData.errorMsg = "Viewing data is missing for the selected date or the date is in the wrong format"
            }
        },
    },
    watch: {
        "fieldData.tempStartDate"(chosendate) {
            this.checkIfError(chosendate)
        },
    },
}
</script>
<style scoped>
input {
    height: 30px !important;
    box-sizing: border-box;
    border: 1px solid #ced4da;
    padding: 2px 5px !important;
}
</style>
